// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__32DZy","rootSmall":"AddTileButton_rootSmall__31LNJ"};